import { employeeRequestGet } from './employeName.api';

export const empoloyeeApi = [employeeRequestGet];
